import {
  WSTable,
  WSTableRowMenuAction
} from "@wingspanhq/fe-component-library";
import { ApiKey } from "@wingspanhq/wingspan-api-sdk";
import React, { useMemo } from "react";
import { getColumns } from "./columns";

type Props = {
  items: ApiKey[];
  loading?: boolean;
  onEdit: (apiKey: ApiKey) => void;
  onRotate: (apiKey: ApiKey) => void;
  onDelete: (apiKey: ApiKey) => void;
};

export const TableApiKeys: React.FC<Props> = props => {
  const tableData = useMemo(
    () => props.items.map(item => ({ id: item.id, data: item })),
    [props.items]
  );

  const columns = useMemo(() => getColumns(), []);

  return (
    <WSTable<ApiKey>
      loading={props.loading}
      showHeader
      columns={columns}
      tableData={tableData}
      rowMenuActions={(rowItem): WSTableRowMenuAction<ApiKey>[] => [
        { label: "Edit", onClick: () => props.onEdit(rowItem.data) },
        { label: "Rotate", onClick: () => props.onRotate(rowItem.data) },
        { label: "Delete", onClick: () => props.onDelete(rowItem.data) }
      ]}
    />
  );
};
